import React from 'react';
import "../../assets/css/intray.css"

export const WrapperModalDialog = (props) => {
    const { children, title, show, close, id, titleCenter } = props;
    const fadeClassName = show ? ' fade in' : ' fade';
    return (
        <div className="myob">
            <div className="inTrayModal">
                <div id={id} className={'modal' + fadeClassName} role="dialog"
                     aria-labelledby="myModalLabel">
                    <div className={'modal-backdrop color' + fadeClassName} onClick={close}
                         style={{zIndex: 2}}/>
                    <div className="modal-dialog" role="document" style={{zIndex: 5}}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                        id="close" onClick={close}>
                                    <span className="myob-icon-close" aria-hidden="true"/>
                                </button>
                                <h4 style={{textAlign: titleCenter ? "center" : "left"}} className="modal-title"
                                    id="myModalLabel">{title}</h4>
                            </div>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
